export const COMPLEX_VARIABLES_SIDEBAR = {
  REPETITIVE_BLOCK_LABEL: {
    key: 'REPETITIVE_BLOCK_LABEL',
    value: 'Repetitive Block',
  },
  DOWNLOAD_DOCUMENT_BUTTON: {
    key: 'DOWNLOAD_DOCUMENT_BUTTON',
    value: 'Download Document',
  },
  DOWNLOADING_DOCUMENT_BUTTON: {
    key: 'DOWNLOADING_DOCUMENT_BUTTON',
    value: 'Downloading Document',
  },
  SEND_TEST_EMAIL_BUTTON: {
    key: 'SEND_TEST_EMAIL_BUTTON',
    value: 'Send Test Email',
  },
  SEND_EMAIL_BUTTON: {
    key: 'SEND_EMAIL_BUTTON',
    value: 'Send Email',
  },
  ADD_NEW_SAMPLE_ACTION: { key: 'ADD_NEW_SAMPLE_ACTION', value: 'Add new sample value' },
  SELECT_DATE_PLACEHOLDER: {
    key: 'SELECT_DATE_PLACEHOLDER',
    value: 'Select Date',
  },
  REPEAT_BLOCK_ACTION: {
    key: 'REPEAT_BLOCK_ACTION',
    value: 'Repeat the block',
  },
  DELETE_REPEATED_BLOCK_CONFIRMATION_TITLE: {
    key: 'DELETE_REPEATED_BLOCK_CONFIRMATION_TITLE',
    value: 'Sure to delete',
  },
  DELETE_REPEATED_BLOCK_TOOLTIP: {
    key: 'DELETE_REPEATED_BLOCK_TOOLTIP',
    value: 'Delete',
  },
  CHART_SECTION_LABEL: {
    key: 'CHART_SECTION_LABEL',
    value: 'Chart Section',
  },
  ADD_CHART_SECTION: {
    key: 'ADD_CHART_SECTION',
    value: 'Add Chart Section',
  },
  SHOW_DESIGN_BUTTON: {
    key: 'SHOW_DESIGN_BUTTON',
    value: 'SHOW THIS DESIGN',
  },
  RELEASE_DESIGN_BUTTON: {
    key: 'RELEASE_DESIGN_BUTTON',
    value: 'RELEASE DESIGN TO CLIENTS',
  },
  DOWNLOAD_PAYLOAD_BUTTON: {
    key: 'DOWNLOAD_PAYLOAD_BUTTON',
    value: 'Download Payload',
  },
  DOWNLOAD_SAMPLE_FORMAT_BUTTON: {
    key: 'DOWNLOAD_SAMPLE_FORMAT_BUTTON',
    value: 'Download request sample',
  },
  SENT_BULK_EMAIL_BUTTON: {
    key: 'SENT_BULK_EMAIL_BUTTON',
    value: 'Send Bulk Emails',
  },
  ADD_ROW_LABEL: {
    key: 'ADD_ROW_LABEL',
    value: 'Add Row',
  },
  DOWNLOAD_AND_PREVIEW_LABEL: {
    key: 'DOWNLOAD_AND_PREVIEW_LABEL',
    value: 'Preview & Download',
  },
  PREVIEW_LABEL: {
    key: 'PREVIEW_LABEL',
    value: 'Preview',
  },
  PREVIEW_AND_SEND_BUTTON: {
    key: 'PREVIEW_AND_SEND_BUTTON',
    value: 'Preview & Send',
  },
  OVERRIDE_VARIABLES_LABEL: {
    key: 'OVERRIDE_VARIABLES_LABEL',
    value: 'Data validations',
  },
  GENERATE_TRANSACTION_BUTTON: {
    key: 'GENERATE_TRANSACTION_BUTTON',
    value: 'Generate Transaction',
  },
};

export const COMPLEX_VARIABLES_OVERRIDE_SIDEBAR = {
  RESET_ALL_LABEL: {
    key: 'RESET_ALL_LABEL',
    value: 'Reset all',
  },
  RESET_LABEL: {
    key: 'RESET_LABEL',
    value: 'Reset',
  },
  REQUIRED_LABEL: {
    key: 'REQUIRED_LABEL',
    value: 'Required',
  },
  LENGTH_LABEL: {
    key: 'LENGTH_LABEL',
    value: 'Length',
  },
  OVERRIDDEN_LABEL: {
    key: 'OVERRIDDEN_LABEL',
    value: 'Modified for this Template',
  },
  ATTACHMENT_USED_VARIABLE_LABEL: {
    key: 'ATTACHMENT_USED_VARIABLE_LABEL',
    value: 'This variable is also used in attchments added in this email template',
  },
  MAX_CHARACTERS_LABEL: {
    key: 'MAX_CHARACTERS_LABEL',
    value: 'Max characters',
  },
  ADD_UPDATE_OVERRIDE_VARIABLE_FAILURE: {
    key: 'ADD_UPDATE_OVERRIDE_VARIABLE_FAILURE',
    value: 'An error occured while trying to override variable data validations',
  },
};
export const CUSTOM_TOOLBAR_TOOLTIP = {
  TEXT_ALIGNMENT_TOOLTIP: {
    key: 'TEXT_ALIGNMENT_TOOLTIP',
    value: 'Alignment',
  },
  EXPAND_TOOLTIP: {
    key: 'EXPAND_TOOLTIP',
    value: 'Expand',
  },
  MINIMIZE_TOOLTIP: {
    key: 'MINIMIZW_TOOLTIP',
    value: 'Minimize',
  },
  SAVE_BUTTON: {
    key: 'SAVE_BUTTON',
    value: 'Save'
  },
  SAVED_BUTTON: {
    key: 'SAVED_BUTTON',
    value: 'Saved'
  }
}

export const ACCESSIBILITY_PREVIEW = {
  STOP_LABEL: { key: 'STOP_LABEL', value: 'Stop' },
  SPEED_LABEL: { key: 'SPEED_LABEL', value: 'Speed' },
  CHANGE_VOICE_LABEL: { key: 'CHANGE_VOICE_LABEL', value: 'Change Voice' },
  VOICE_READING_NOT_SUPPORTED: {
    key: 'VOICE_READING_NOT_SUPPORTED',
    value: "Your browser doesn't support voice reading.",
  },
  VOICE_NOT_AVAILABLE: {
    key: 'VOICE_NOT_AVAILABLE',
    value: "This device doesn't have any voice options, or there's no voice available for the content's language.",
  },
  CONTENT_NOT_AVAILABLE: {
    key: 'CONTENT_NOT_AVAILABLE',
    value: 'No content is currently available to read.',
  },
};
